const areEqual = (left, right) => JSON.stringify(left) === JSON.stringify(right);

export const buildSwmsContentManagementChanges = (
  initialDocument = {},
  submittedDocument = {}
) => {
  const sectionKeys = Array.from(new Set([
    ...Object.keys(initialDocument.sections || {}),
    ...Object.keys(submittedDocument.sections || {})
  ])).filter((key) => key.indexOf("swms_content_management_") === 0);
  const items = [];

  sectionKeys.forEach((sectionKey) => {
    const initialSection = initialDocument.sections && initialDocument.sections[sectionKey]
      ? initialDocument.sections[sectionKey]
      : {};
    const submittedSection = submittedDocument.sections && submittedDocument.sections[sectionKey]
      ? submittedDocument.sections[sectionKey]
      : {};
    const initialData = initialSection.data || {};
    const submittedData = submittedSection.data || {};
    const sectionLabel = submittedSection.display_name || initialSection.display_name || sectionKey;
    const changes = [];

    if (!areEqual(Number(initialData.toggle), Number(submittedData.toggle))) {
      changes.push({
        field_name: "toggle",
        field_label: `${sectionLabel} Toggle`,
        change_type: "inline",
        action: Number(submittedData.toggle) === 1 ? "toggled_on" : "toggled_off",
        previous_value: Number(initialData.toggle),
        new_value: Number(submittedData.toggle)
      });
    }

    if (!areEqual(initialData.description, submittedData.description)) {
      changes.push({
        field_name: "description",
        field_label: sectionLabel,
        change_type: "rich_text",
        action: "updated",
        previous_value: initialData.description === undefined ? null : initialData.description,
        new_value: submittedData.description === undefined ? null : submittedData.description
      });
    }

    if (changes.length > 0) {
      items.push({
        item_id: null,
        item_label: null,
        section_changes: [{
          section_key: sectionKey,
          section_label: sectionLabel,
          changes
        }]
      });
    }
  });

  return items;
};
